import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unsaved-alert',
  standalone: false,
  templateUrl: './unsaved-alert.component.html',
  styleUrl: './unsaved-alert.component.scss'
})
export class UnsavedAlertComponent {
  title:string = 'Oops! Not Saved.';
  message:string = 'You have unsaved changes. Are you sure you want to leave?';
    constructor(public dialogRef: MatDialogRef<UnsavedAlertComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) { 
        // this.title=data.title;
        // this.message=data.message
        dialogRef.disableClose = true;
      }
  
    onCloseBtn(){
      this.dialogRef.close({ operation: 'close' });
    }
    
    onConfim(){
      this.dialogRef.close({ operation: 'confirm' });
    }
    
  }
  
